module.exports = __webpack_public_path__ + "img/introBg.40f79db.85572ab6.jpg";